import React from 'react';

export const FaceEmbarrassedIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
        fill="#FFB02E"
      />
      <path
        d="M9.98156 13.1909C10.0296 12.9436 10.1397 12.6405 10.349 12.4125C10.5283 12.2171 10.847 12 11.4999 12C12.1417 12 12.4685 12.2216 12.6572 12.4288C12.8753 12.6683 12.9804 12.9737 13.0147 13.1711C13.1092 13.7152 13.6269 14.0797 14.171 13.9853C14.7152 13.8908 15.0797 13.373 14.9852 12.8289C14.9062 12.374 14.6799 11.6794 14.1357 11.082C13.562 10.4522 12.6955 10 11.4999 10C10.3156 10 9.45269 10.4313 8.87551 11.0601C8.32826 11.6564 8.10696 12.3533 8.01833 12.8091C7.91291 13.3513 8.26694 13.8762 8.80907 13.9816C9.3512 14.087 9.87614 13.733 9.98156 13.1909Z"
        fill="#402A32"
      />
      <path
        d="M18.9818 13.1909C19.0299 12.9436 19.14 12.6405 19.3492 12.4125C19.5285 12.2171 19.8472 12 20.5002 12C21.1419 12 21.4687 12.2216 21.6574 12.4288C21.8756 12.6683 21.9807 12.9737 22.0149 13.1711C22.1094 13.7152 22.6271 14.0797 23.1713 13.9853C23.7154 13.8908 24.0799 13.373 23.9854 12.8289C23.9064 12.374 23.6802 11.6794 23.1359 11.082C22.5623 10.4522 21.6957 10 20.5002 10C19.3159 10 18.4529 10.4313 17.8758 11.0601C17.3285 11.6564 17.1072 12.3533 17.0186 12.8091C16.9132 13.3513 17.2672 13.8762 17.8093 13.9816C18.3514 14.087 18.8764 13.733 18.9818 13.1909Z"
        fill="#402A32"
      />
      <path d="M16 25C7 25 7 16 7 16H25C25 16 25 25 16 25Z" fill="#BB1D80" />
      <path d="M8 16.5V16H24V16.5C24 17.0523 23.5523 17.5 23 17.5H9C8.44772 17.5 8 17.0523 8 16.5Z" fill="white" />
      <path
        d="M24 4.5C24 3.11929 25.1193 2 26.5 2C27.8807 2 29 3.11929 29 4.5V9.5C29 10.8807 27.8807 12 26.5 12C25.1193 12 24 10.8807 24 9.5V4.5Z"
        fill="#3F5FFF"
      />
    </svg>
  );
};
